import { PlatformSection } from '@/common/components';
import { useNewTranslations } from '@/common/translations';

import { LastFiveGames } from '../../components';
import type { LatestGame } from '../../components/LastFiveGames/LastFiveGames.types';
import { matchStageTranslationMap } from '../../constants';
import { usePrematchData } from '../../hooks';
import type { LastMatch as LastMatchApi } from '../../types';

export default function LastFiveGamesSection() {
  const translate = useNewTranslations();
  const { teams, statistics } = usePrematchData();

  const mapLatestApiGames = (games: LastMatchApi[]): LatestGame[] =>
    games.map((game) => ({
      ...game,
      stage: game.stage ? translate(matchStageTranslationMap[game.stage]) : game.stage,
      result: game.outcome,
      homeGoalScorers: game.homeGoalscorers,
      awayGoalScorers: game.awayGoalscorers,
    }));

  const latestHomeGames = mapLatestApiGames(statistics?.lastFiveGames?.homeLastMatches || []);
  const latestAwayGames = mapLatestApiGames(statistics?.lastFiveGames?.awayLastMatches || []);

  const areBothTeamsWithoutGames = latestHomeGames.length === 0 && latestAwayGames.length === 0;

  if (!statistics?.lastFiveGames || areBothTeamsWithoutGames) {
    return null;
  }

  return (
    <PlatformSection name={translate('PreMatchStats.Last5Games')} contentClassName="p-0">
      <LastFiveGames
        homeTeamName={teams.home.name}
        awayTeamName={teams.away.name}
        latestHomeGames={latestHomeGames}
        latestAwayGames={latestAwayGames}
      />
    </PlatformSection>
  );
}
